import { useEffect, useState } from "react";
import { api } from "../lib/api";

// Public feature-flag hook. Pings /api/config/features once per session
// and caches the result. Currently gates the SMS surface (phone verify
// on Account, phone step on Signup) while Twilio is locked pending the
// fraud-team review (INC-2026-09-25). Falls SAFE-OFF: if the fetch
// fails, we treat SMS as disabled so nothing tries to hit Twilio.
let _cache = null;
let _inflight = null;

export function useFeatureFlags() {
  const [flags, setFlags] = useState(_cache);
  useEffect(() => {
    if (_cache) return;
    if (!_inflight) {
      _inflight = api
        .get("/config/features")
        .then((r) => {
          _cache = r.data || {};
          return _cache;
        })
        .catch(() => {
          // Safe-off default.
          _cache = { sms_enabled: false, phone_signup_enabled: false };
          return _cache;
        });
    }
    _inflight.then((c) => setFlags(c));
  }, []);
  return flags || { sms_enabled: false, phone_signup_enabled: false };
}
